import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { injectIntl } from 'react-intl-next';
import ExpandIcon from '@atlaskit/icon/glyph/chevron-down';
import ToolbarButton from '../../../../ui/ToolbarButton';
import Dropdown from '../../../../ui/Dropdown';
import Alignment from '../../../../ui/Alignment';
import { expandIconWrapper, triggerWrapper, wrapper } from './styles';
import { separatorStyles } from '@atlaskit/editor-common/styles';
import { IconMap } from './icon-map';
import { messages } from './messages';
export var AlignmentToolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(AlignmentToolbar, _React$Component);
  var _super = _createSuper(AlignmentToolbar);
  function AlignmentToolbar() {
    var _this;
    _classCallCheck(this, AlignmentToolbar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "toolbarItemRef", /*#__PURE__*/React.createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      isOpenedByKeyboard: false
    });
    _defineProperty(_assertThisInitialized(_this), "changeAlignment", function (align, togglePopup) {
      if (togglePopup) {
        _this.toggleOpen();
      }
      return _this.props.changeAlignment(align);
    });
    _defineProperty(_assertThisInitialized(_this), "toggleOpen", function () {
      _this.setState({
        isOpen: !_this.state.isOpen,
        isOpenedByKeyboard: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleOpenByKeyboard", function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        _this.setState({
          isOpen: !_this.state.isOpen,
          isOpenedByKeyboard: true
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hide", function (attrs) {
      if (_this.state.isOpen) {
        _this.setState({
          isOpen: false
        });
        if ((attrs === null || attrs === void 0 ? void 0 : attrs.event) instanceof KeyboardEvent && attrs.event.key === 'Escape') {
          var _this$toolbarItemRef, _this$toolbarItemRef$;
          (_this$toolbarItemRef = _this.toolbarItemRef) === null || _this$toolbarItemRef === void 0 ? void 0 : (_this$toolbarItemRef$ = _this$toolbarItemRef.current) === null || _this$toolbarItemRef$ === void 0 ? void 0 : _this$toolbarItemRef$.focus();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "hideOnEscape", function () {
      var _this$toolbarItemRef2, _this$toolbarItemRef3;
      _this.hide();
      (_this$toolbarItemRef2 = _this.toolbarItemRef) === null || _this$toolbarItemRef2 === void 0 ? void 0 : (_this$toolbarItemRef3 = _this$toolbarItemRef2.current) === null || _this$toolbarItemRef3 === void 0 ? void 0 : _this$toolbarItemRef3.focus();
    });
    return _this;
  }
  _createClass(AlignmentToolbar, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        isOpen = _this$state.isOpen,
        isOpenedByKeyboard = _this$state.isOpenedByKeyboard;
      var _this$props = this.props,
        popupsMountPoint = _this$props.popupsMountPoint,
        popupsBoundariesElement = _this$props.popupsBoundariesElement,
        popupsScrollableElement = _this$props.popupsScrollableElement,
        isReducedSpacing = _this$props.isReducedSpacing,
        pluginState = _this$props.pluginState,
        disabled = _this$props.disabled,
        intl = _this$props.intl;
      var title = intl.formatMessage(messages.alignment);
      return jsx("span", {
        css: wrapper
      }, jsx(Dropdown, {
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        isOpen: isOpen,
        shouldFocusFirstItem: function shouldFocusFirstItem() {
          if (isOpenedByKeyboard) {
            _this2.setState(_objectSpread(_objectSpread({}, _this2.state), {}, {
              isOpenedByKeyboard: false
            }));
          }
          return isOpenedByKeyboard;
        },
        onOpenChange: function onOpenChange(_ref) {
          var isOpen = _ref.isOpen;
          _this2.setState({
            isOpen: isOpen
          });
        },
        handleClickOutside: function handleClickOutside(event) {
          if (event instanceof MouseEvent) {
            _this2.hide({
              isOpen: false,
              event: event
            });
          }
        },
        handleEscapeKeydown: this.hideOnEscape,
        fitWidth: 112,
        fitHeight: 80,
        closeOnTab: true,
        trigger: jsx(ToolbarButton, {
          spacing: isReducedSpacing ? 'none' : 'default',
          disabled: disabled,
          selected: isOpen,
          title: title,
          className: "align-btn",
          "aria-label": title,
          "aria-expanded": isOpen,
          "aria-haspopup": true,
          onClick: this.toggleOpen,
          onKeyDown: this.toggleOpenByKeyboard,
          iconBefore: jsx("div", {
            css: triggerWrapper
          }, jsx(IconMap, {
            alignment: pluginState.align
          }), jsx("span", {
            css: expandIconWrapper
          }, jsx(ExpandIcon, {
            label: ""
          }))),
          ref: this.toolbarItemRef
        })
      }, jsx(Alignment, {
        onClick: function onClick(align) {
          return _this2.changeAlignment(align, false);
        },
        selectedAlignment: pluginState.align
      })), jsx("span", {
        css: separatorStyles
      }));
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;
      if (this.state.isOpen && this.state.isOpenedByKeyboard) {
        // by triggering the keyboard event with a setTimeout, we ensure that the tooltip
        // associated with the alignment button doesn't render until the next render cycle
        // where the popup will be correctly positioned and the relative position of the tooltip
        // will not overlap with the button.
        setTimeout(function () {
          var _this3$toolbarItemRef;
          var keyboardEvent = new KeyboardEvent('keydown', {
            bubbles: true,
            key: 'ArrowDown'
          });
          (_this3$toolbarItemRef = _this3.toolbarItemRef.current) === null || _this3$toolbarItemRef === void 0 ? void 0 : _this3$toolbarItemRef.dispatchEvent(keyboardEvent);
        }, 0);
      }
    }
  }]);
  return AlignmentToolbar;
}(React.Component);
_defineProperty(AlignmentToolbar, "displayName", 'AlignmentToolbar');
export default injectIntl(AlignmentToolbar);